import React, { useEffect, useState } from 'react'
import { Delete_SubPeriod_Api, GetAll_Paging_SubPeriod_Api } from '../../API/SubPeriodApi';
import { Button, Col, Modal, Pagination, Row } from 'antd';
import { CloseOutlined, DeleteOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, RollbackOutlined } from '@ant-design/icons';
import { ConfigProvider } from 'antd';
import faIR from 'antd/locale/fa_IR';
// ======================================================================
export const AllSubPeriodComponent = ({ setLoading, showMessage, periodId, periodTitle, version, currentPage, setCurrentPage, onAddClick, onEdit, onRowDeleted, onBackClick }) => {
    // ======================================================================
    const [pageCount, setPageCount] = useState(1);
    const [subPeriods, setSubPeriods] = useState(0);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, []);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [periodId, version, currentPage]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Paging_SubPeriod_Api({ pageNumber: currentPage, periodId: periodId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPageCount(data.messageData.pageCount * 10)
                setSubPeriods(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const deleteRow = async (id) => {
        setLoading(true);
        try {
            let data = await Delete_SubPeriod_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        subPeriods ? (
            <>
                <Row className='sectionTitle'>
                    <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                        <Button onClick={() => onBackClick()}>
                            <DoubleRightOutlined />
                            بازگشت
                        </Button>
                    </Col>
                    <Col xs={10} sm={10} md={10} lg={14} xl={14}>
                        <h2 >
                            زیر دوره های {periodTitle}
                        </h2>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                        <Button className='btn-primary' onClick={() => onAddClick()} >
                            <PlusOutlined />
                            ایجاد رکورد جدید</Button>

                    </Col>
                </Row>

                <div className='container'>
                    {subPeriods.map((subPeriod, key) =>
                        <>
                            <Row key={key} className="valueRow">
                                <Col span={15} style={{ padding: "5px" }}>  {subPeriod.title} </Col>
                                <Col span={9} style={{ textAlign: "left" }}>
                                    <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onEdit(subPeriod.id)}>
                                        <EditOutlined />
                                        ویرایش
                                    </Button>
                                    <Button
                                        className='btn-danger'
                                        onClick={() => {
                                            Modal.confirm({
                                                title: 'آیا از حذف ' + subPeriod.title + ' اطمینان دارید؟',
                                                onOk: () => { deleteRow(subPeriod.id) },
                                                footer: (_, { OkBtn, CancelBtn }) => (
                                                    <>
                                                        <CancelBtn />
                                                        <OkBtn />
                                                    </>
                                                ),
                                            });
                                        }}
                                    >
                                        <DeleteOutlined />
                                        حذف</Button>

                                </Col>
                            </Row>
                        </>
                    )}
                </div>
                <ConfigProvider direction="rtl" locale={faIR}>
                    <Pagination current={currentPage} align="center"
                        showSizeChanger={false}
                        showQuickJumper={false}
                        onChange={(page) => setCurrentPage(page)} total={pageCount} />
                </ConfigProvider>
            </>
        ) : (<></>)
    )
}